export const ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/forgot-password',
  RESET_PASSWORD_CONFIRMATION: '/change-password',
  VERIFY_EMAIL: '/verify-email',
  MAP_OVERVIEW: '/',
  PROFILE: '/profile',
  DRIVERS: '/drivers',
  VEHICLES: '/vehicles',
  SAFETY_CONCERNS: '/safety-concerns',
  SAFETY: '/safety',
  SAFETY_ID: '/safety/:id',
  REPORTS: '/reports',
  LIVEVIEW: '/liveview/:plate_no',
  LIVEVIEW_V2: '/liveview-v2/:plate_no',
  VEHICLE_SUMMARY: '/reports/vehicle-summary',
  DRIVER_PERFORMANCE: '/reports/driver-performance',
  MILEAGE_REPORT: '/reports/mileage',
  RESOURCE_UTILIZATION: '/reports/resource-utilization',
  IDLE_REPORT: '/reports/idle',
  VEHICLE_UTILIZATION: '/reports/vehicle-utilization',
  HOURS_OF_SERVICE: '/reports/hours-of-service',
  DAILY_VEHICLE: '/reports/daily-vehicle',
  NOTIFICATIONS: '/notifications',
  DRIVER_UTILIZATION: '/reports/driver-utilization',
  MISSING_DRIVER: '/reports/missing-driver',
  MAINTENANCE: '/maintenance',
  CREATE_SCHEDULE: '/maintenance/create-schedule',
  EDIT_SCHEDULE: '/maintenance/edit-schedule/:mtId?',
  VIEW_SCHEDULE: '/maintenance/view-schedule/:mtId?',
  ADMIN: '/admin',
  ADMIN_DEVICE: '/admin/device-management',
  ADMIN_USER: '/admin/user-management',
  ADMIN_ROLE: '/admin/role-management',
  ADMIN_VEHICLE: '/admin/vehicle-management',
  ADMIN_ORGANIZATION: '/admin/organization-management',
  ADMIN_RELEASE_VERSION: '/admin/release-version-management',
  GROUPS: '/groups',
  VIEWMANAGEGROUPS: '/groups/view-manage-group/:grpId?',
  ROUTES_OPTIMIZATION: '/routes',
  VIEW_ROUTE: '/routes/view-route/:routeId?',
} as const; // making sure it is read only

// Create a union type of the values of the ROUTES object
export type RouteValues = (typeof ROUTES)[keyof typeof ROUTES];
